import React, { Component, useState, useEffect, useRef } from 'react';
import { Image, Button, Icon, Header,  Message, Container, Segment } from 'semantic-ui-react'



function Info() {


    return (
        
        <>
        <Segment size='huge' textAlign='center' color='blue' inverted>About this Page</Segment>
        <Segment>
        <Container text>
            <Header as='h2'>Legal</Header>
            <p>
                This site is operated by Moeller IT Consulting LLC, Minneapolis MN, USA.
                <p/><p/>
                It is solely intended for demo and learning purposes. The page collects
                personal information in form of the registered user's email address.
                This information is only used for authentication and will be deleted upon request. 
                <p/><p/>
                The owner also reserves the right to remove accounts that were not in use for 
                a longer period of time as well as accounts that appear to perform malicious activties.
                <p/><p/>
                The site may also use cookies for functional reasons, not for tracking of user activities.
            </p>
        </Container>    
        </Segment>
        <Segment>        
        <Container text>
        <Header as='h2'>Technical</Header>
        <p>
            Northwind Trading is a demo application based on the Northwind relational database schema.
            Goal was to build a complete prototype of a business application that runs serverless with 
            minimal effort in coding while a relational database with SQL interface should be retained. 
        </p><p>
            The architecture diagram shows the used cloud services and their interaction.
        </p>
        </Container>
        </Segment>
        <Segment textAlign='center'>
            
            <Image src="/architecture.png" centered/>
        </Segment>
        <Segment>
        </Segment>

        </>
    )
}

export default Info